"use client";

import { useEffect, useRef } from "react";
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Scroll({ children, locked }) {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Siempre arrancar desde el top para no romper animaciones
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    if (window.matchMedia("(max-width: 768px), (max-width: 1200px) and (orientation: portrait)").matches) {
      const discoverEl = document.getElementById("discover");
      const loaderBar = document.getElementById("loaderbar");
      const percentEl = document.querySelector("#percent span");
      let hidden = false;
      let lastPercent = -1;
      const onScroll = () => {
        const max = Math.max(
          document.documentElement.scrollHeight - window.innerHeight,
          1,
        );
        const progress = Math.min(Math.max(window.scrollY / max, 0), 1);
        if (loaderBar) loaderBar.style.transform = `scaleX(${progress})`;
        if (percentEl) {
          const p = Math.round(progress * 100);
          if (p !== lastPercent) {
            percentEl.textContent = p;
            lastPercent = p;
          }
        }
        if (discoverEl) {
          const alpha = Math.max(0, 1 - progress / 0.05);
          discoverEl.style.opacity = alpha;
          const shouldHide = alpha === 0;
          if (shouldHide !== hidden) {
            discoverEl.style.visibility = shouldHide ? "hidden" : "visible";
            hidden = shouldHide;
          }
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      return () => window.removeEventListener("scroll", onScroll);
    }

    const lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
      smoothTouch: false,
    });

    const loaderBar = document.getElementById("loaderbar");
    const percentEl = document.querySelector("#percent span");
    const discoverEl = document.getElementById("discover");
    let lastPercent = -1;
    let discoverHidden = false;
    const onLenisScroll = ({ progress }) => {
      ScrollTrigger.update();
      if (loaderBar) {
        loaderBar.style.transform = `scaleX(${progress})`;
      }
      if (percentEl) {
        const p = Math.round(progress * 100);
        if (p !== lastPercent) {
          percentEl.textContent = p;
          lastPercent = p;
        }
      }
      if (discoverEl) {
        const alpha = Math.max(0, 1 - progress / 0.01);
        discoverEl.style.opacity = alpha;
        const shouldHide = alpha === 0;
        if (shouldHide !== discoverHidden) {
          discoverEl.style.visibility = shouldHide ? "hidden" : "visible";
          discoverHidden = shouldHide;
        }
      }
    };

    lenisRef.current = lenis;
    // Expuesto para que el modal legal pueda parar/reanudar el scroll de la home.
    window.__keldaiHomeLenis = lenis;
    lenis.on("scroll", onLenisScroll);

    const tick = (time) => {
      lenis.raf(time * 1000);
    };

    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(tick);
      lenis.destroy();
      lenisRef.current = null;
      if (window.__keldaiHomeLenis === lenis) window.__keldaiHomeLenis = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) {
      locked ? lenisRef.current.stop() : lenisRef.current.start();
    }
    document.body.style.overflow = locked ? 'hidden' : '';
    document.documentElement.style.overflow = locked ? 'hidden' : '';

    const preventTouch = (e) => e.preventDefault();
    if (locked) {
      document.addEventListener('touchmove', preventTouch, { passive: false });
    }
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.removeEventListener('touchmove', preventTouch);
    };
  }, [locked]);

  return <div id="lenis-root">{children}</div>;
}
